<div class="card mb-5 " [class.borderless-chart-card]="data?.styleVariant === 'embedded'"> 
    <div class="card-header" style="border-bottom: none;">
        <div class="card-title d-flex flex-column">
            <h4>{{data.title}}</h4>
        </div>
    </div>
    <div class="card-body">
        <div #chartContainer id="{{data.widgetId}}" [style.height]="data?.height || '300px'"></div>
    </div>
</div>
